import { lazy, Suspense } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { ViewportCenterCircle } from "@newComponents/common/ViewportCenterCircle";

const TemplateList = lazy(() => import("@newPages/templates/TemplateList"));
const TemplateAdd = lazy(() => import("@newPages/templates/TemplateAdd"));
const TemplateView = lazy(() => import("@newPages/templates/TemplateView"));

export function TemplateRoute() {
  const match = useRouteMatch();

  return (
    <Suspense fallback={<ViewportCenterCircle />}>
      <Switch>
        <Route exact path={`${match.url}`} component={TemplateList} />
        <Route exact path={`${match.url}/add`} component={TemplateAdd} />
        <Route exact path={`${match.url}/:templateId`} component={TemplateView} />
        <Redirect from="*" to="/404?tr" />
      </Switch>
    </Suspense>
  );
}
